module.exports = __webpack_public_path__ + "img/y.b07aabd6.png";